// src/components/about/StorySection.js
import React, { useEffect, useRef } from 'react';
import { fadeIn } from '../../utils/gsapAnimations';

function StorySection({ content }) {
  const sectionRef = useRef(null);

  useEffect(() => {
    fadeIn(sectionRef.current, 0.3);
  }, []);

  return (
    <section ref={sectionRef} className="py-12">
      <h2 className="text-2xl font-playfair-display font-semibold text-primary mb-6 text-center">
        { 'Our Story'}
      </h2>
      <div className="flex flex-col md:flex-row items-center gap-8">
       
        <p className="font-montserrat text-secondary">
          {content?.description ||
            'Tell us about your story.'}
        </p>
      </div>
    </section>
  );
}

export default StorySection;